<div class="tabs">
  <ng-content select="[listPageLayoutHeaderTabs]"></ng-content>
</div>
<div class="controls">
  <ng-content select="[listPageLayoutHeaderControls]"></ng-content>
</div>
